import { render, staticRenderFns } from "./drawer_weightList.vue?vue&type=template&id=20152ef0&scoped=true&"
import script from "./drawer_weightList.vue?vue&type=script&lang=js&"
export * from "./drawer_weightList.vue?vue&type=script&lang=js&"
import style0 from "./drawer_weightList.vue?vue&type=style&index=0&id=20152ef0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20152ef0",
  null
  
)

export default component.exports